<template>
  <div class="rating-container">
    <div class="rating-header">
        <span class="title">{{ $t('hm.title.rating') }}</span>
        <HmPersonalInfo class="hm-info" v-if="displayPersonalInfo"></HmPersonalInfo>
        <Language class="language"/>
    </div>
    <div class="rating-content">
      <RatingInfo class="rating-info" :dataInfo="ratingInfoData"></RatingInfo>
      <el-tabs class="rating-tabs" v-model="activeName" @tab-click="handleClick">
        <template v-if="commentList.length > 0">
          <el-tab-pane name="1">
            <span class="tabs-label" slot="label">{{ $t('hm.label.tab.rating.comments') }}</span>
            <RatingComments :commentList="commentList"/>
            <NextStepButton @handelNextSetp="handelNextSetp" :showBackButton="false"/>
          </el-tab-pane>
        </template>
        <el-tab-pane name="2">
          <span class="tabs-label" slot="label">{{ $t('hm.label.tab.rating.resume') }}</span>
            <RatingResume :resumeData="resumeData" :jobId="ratingInfoData.job.id" :candidateId="ratingInfoData.candidate.id" @videoPop='handelVideoPop'/>
          <NextStepButton @handelNextSetp="handelNextSetp" @handelBackSetp="handelBackSetp" :showBackButton="commentList.length > 0"/>
        </el-tab-pane>
        <template v-if="show_assessment">
          <el-tab-pane name="3">
            <span class="tabs-label" slot="label">{{ $t('hm.label.tab.rating.report') }}</span>
            <iframe ref="iframe" @load="handelIframeLoad" class="report-iframe" :src="reportUrl"/>
            <NextStepButton @handelNextSetp="handelNextSetp" @handelBackSetp="handelBackSetp"/>
          </el-tab-pane>
        </template>
        <template v-if="ratingList.length > 0">
          <el-tab-pane name="4">
            <span class="tabs-label" slot="label">{{ $t('hm.label.tab.rating.rating') }}</span>
            <RatingRate
              ref="ratingRate"
              :ratingList="ratingList"
              :readOnly="overall.rateStatus ? true : false"
              :showAnswer="true"
              @videoPop='handelVideoPop'/>
            <NextStepButton @handelNextSetp="handelNextSetp" @handelBackSetp="handelBackSetp"/>
          </el-tab-pane>
        </template>
        <el-tab-pane name="5">
          <span class="tabs-label" slot="label">{{ $t('hm.label.tab.rating.overall') }}</span>
          <RatingOverall ref="overall" :overall="overall" :isEdit="isEdit" :buttonOperate="overallOperate"/>
          <NextStepButton :nextButtonTitle="$t('hm.btn.submit')" @handelBackSetp="handelBackSetp" @handelNextSetp="handelRating"/>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        :title="popInfo.title"
        :visible.sync="popInfo.showVideoPop"
        width="50%"
        :before-close="handelClosePop">
        <div class="video-container">
          <video class="video" controls="controls" autoplay="autoplay" :src="popInfo.videoUrl"></video>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import HmPersonalInfo from './components/hmPersonalInfo.vue'
import RatingInfo from '../common/components/ratingInfo.vue'
import RatingComments from './components/comments.vue'
import RatingRate from './components/rating.vue'
import RatingOverall from './components/overall.vue'
import RatingResume from './components/resume.vue'
import NextStepButton from './components/nextStep.vue'
import Language from '../common/language.vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
import mixin from '../mixin'
import { getHmToken } from '@/utils/hmToken'

const RATING_APPROVED = 2
const RATING_UNDERMINED = 0

export default {
  mixins: [mixin],
  components: {
    HmPersonalInfo,
    RatingInfo,
    Language,
    RatingComments,
    RatingResume,
    RatingRate,
    RatingOverall,
    NextStepButton
  },
  props: {

  },
  data () {
    return {
      displayPersonalInfo: true,
      showLoading: false,
      activeName: '2',
      textSize: {
        minRows: 3,
        maxRows: 5
      },
      commentList: [],
      ratingList: [],
      reportUrl: '',
      resumeData: {},
      show_assessment: false,
      ratingInfoData: {
        company: {
          id: '',
          cn_name: '',
          name: '',
          logo_url: ''
        },
        job: {
          id: '',
          cn_title: '',
          title: ''
        },
        candidate: {
          id: '',
          name: '',
          show_assessment: false
        }
      },
      overall: {
        rateScore: 0,
        rateStatus: null,
        status: null,
        comment: ''
      },
      overallOperate: {
        reject: {
          hidden: false,
          disabled: false,
          labelI18n: 'hm.label.rating.notRecommended',
          onButtonClick: this.handelRejectClick
        },
        padding: {
          hidden: true,
          disabled: false,
          labelI18n: 'hm.label.pending',
          onButtonClick: this.handelPaddingClick
        },
        approve: {
          hidden: false,
          disabled: false,
          labelI18n: 'hm.label.rating.Recommended',
          onButtonClick: this.handelApproveClick
        }
      },
      popInfo: {
        showVideoPop: false,
        title: '',
        videoUrl: ''
      },
      btnSaveType: null,
      isEdit: false
    }
  },
  computed: {
    inviteCode () {
      return this.$route.params.inviteCode
    },
    verifyOverall () {
      return this.$refs.overall.verifyOverall()
    }
  },
  async created () {
    await this.initData()
  },
  beforeDestroy () {

  },
  methods: {
    ...mapActions('hm', ['getRatingInfoByInviteCode', 'saveRatingResultByInviteCode']),
    async initData () {
      this.showLoading = true
      try {
        const resp = await this.getRatingInfoByInviteCode(this.inviteCode)
        if (resp && resp.job) {
          this.ratingInfoData.job = resp.job
          this.ratingInfoData.company = resp.company
          this.ratingInfoData.candidate = resp.candidate
          this.commentList = _.filter(resp.applicant_comment_list, item => item.comment)
          this.ratingList = resp.question?.list || []
          this.overall = {
            rateScore: resp.total_rate,
            rateStatus: resp.total_rate ? 1 : 0,
            status: resp.status,
            comment: resp.comments
          }
          if (resp.total_rate) {
            this.isEdit = true
          } else {
            this.overall.status = resp.status === 1 ? null : resp.status
          }
          this.resumeData = resp.resume
          this.show_assessment = this.ratingInfoData.candidate.show_assessment
          if (this.commentList.length > 0) {
            this.handelBackSetp()
          }
        } else {
          this.$message.error(this.$t('hm.tips.invitcodeError'))
          setTimeout(() => {
            this.$router.push({ name: 'hmHomePage' })
          }, 1500)
        }
      } finally {
        this.showLoading = false
      }
    },
    handleClick (tab, event) {
      if (this.activeName === '3' && !this.reportUrl) {
        const hmToken = getHmToken()
        this.reportUrl = this.$DjangoBaseUrl(`hm/report/${this.inviteCode}/?token=${hmToken}&show_download_icon_in_html=1&html=1`)
      }
    },
    handelRejectClick () {
      this.overall.rateStatus = 0
      this.btnSaveType = RATING_UNDERMINED
    },
    handelPaddingClick () {

    },
    handelApproveClick () {
      this.overall.rateStatus = 2
      this.btnSaveType = RATING_APPROVED
    },
    async verifyDateForRating () {
      const result = await this.verifyRating()
      if (!result) {
        this.activeName = '4'
      }
      return this.verifyOverall && result
    },
    async verifyRating () {
      if (!this.ratingList.length > 0) {
        return true
      }
      if (!this.$refs.ratingRate) {
        let result = false
        await this.$nextTick()
        result = this.$refs.ratingRate?.verifyRatingList()
        if (result === undefined && this.ratingList.length > 0) {
          this.handelBackSetp()
          return false
        }
        return result
      }
      return this.$refs.ratingRate?.verifyRatingList()
    },
    async handelRating () {
      const result = await this.verifyDateForRating()
      if (!result) {
        return
      }
      if (!_.includes([RATING_UNDERMINED, RATING_APPROVED], this.btnSaveType)) {
        return
      }
      const status = this.btnSaveType
      const params = {
        overall: {
          status: status,
          comment: this.overall.comment,
          rate_score: this.overall.rateScore
        },
        rating_list: this.ratingList
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.saveRatingResultByInviteCode({ inviteCode: this.inviteCode, params: params })
        if (resp) {
          this.$message.success(this.$t('hm.tips.ratingSuccess'))
          setTimeout(() => {
            this.$router.push({ name: 'hmHomePage' })
          }, 1500)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handelVideoPop (item) {
      this.popInfo.title = item.title
      this.popInfo.videoUrl = item.private_mp4_url
      this.popInfo.showVideoPop = true
    },
    handelClosePop () {
      this.popInfo.showVideoPop = false
      this.popInfo.title = ''
      this.popInfo.videoUrl = ''
    },
    async handelNextSetp () {
      if (this.activeName === '4') {
        const result = await this.verifyRating()
        if (!result) {
          return
        }
      }
      if (this.activeName === '2' && !this.show_assessment) {
        this.activeName = _.toString(++this.activeName)
      }
      if (this.activeName === '3' && !this.ratingList.length > 0) {
        this.activeName = _.toString(++this.activeName)
      }
      this.activeName = _.toString(++this.activeName)
      if (this.activeName === '3' && this.show_assessment && !this.reportUrl) {
        const hmToken = getHmToken()
        this.reportUrl = this.$DjangoBaseUrl(`hm/report/${this.inviteCode}/?token=${hmToken}&show_download_icon_in_html=1&html=1`)
      }
      setTimeout(() => {
        document.querySelector('.rating-header .title').scrollIntoView({ block: 'center', behavior: 'smooth' })
      }, 200)
    },
    handelBackSetp () {
      if (this.activeName === '5' && !this.ratingList.length > 0) {
        this.activeName = _.toString(--this.activeName)
      }
      if (this.activeName === '4' && !this.reportUrl) {
        this.activeName = _.toString(--this.activeName)
      }
      this.activeName = _.toString(--this.activeName)
      setTimeout(() => {
        document.querySelector('.rating-header .title').scrollIntoView({ block: 'center', behavior: 'smooth' })
      }, 200)
    },
    async handelIframeLoad () {
      await new Promise(this.resetIframeCss)
    },
    resetIframeCss (resolve) {
      this.$nextTick(() => {
        const contentDocument = this.$refs.iframe.contentWindow.document
        if (!contentDocument) {
          setTimeout(() => this.resetIframeCss(resolve), 500)
          return
        }
        const html = contentDocument.querySelector('html')
        if (!html) {
          setTimeout(() => this.resetIframeCss(resolve), 500)
          return
        }
        html.style.margin = 'auto'
        if (html.scrollHeight > 1000) {
          this.$refs.iframe.style.height = html.scrollHeight + 'px'
        }
        resolve()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rating-container {
  background-color: #f7f7f7;

  .rating-header {
      height: 110px;
      background-color: #0b0d1a;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 100px;
      position: relative;

      .title {
          color: #FFFFFF;
          font-size: 28px;
          font-weight: 600;
      }

      .hm-info {
        margin-right: 10%;
      }

      .language {
        position: absolute;
        right: 5%;
        top: 25px;
        width: auto;
      }
  }

  .rating-content {
    padding: 30px 100px;

    .tabs-label {
      padding: 0 30px;
    }

    .report-iframe {
      width: 100%;
      height: 100vh;
      border: 0;
    }

    ::v-deep .rating-info {
      margin: 0 0 20px 0;
      padding: 30px 40px;

      > div {
        > span {
          font-size: 20px;
        }

        .iconfont {
          font-size: 30px;

          &::after {
            top: 84%;
          }
        }

        .content {
          margin-left: 20px;
        }
      }
    }

    ::v-deep .rating-tabs {
      padding-top: 15px;

      &.el-tabs {
        .el-tabs__content {
          padding-top: 20px;
        }

        .el-tabs__item {
          font-size: 18px;
          color: #808080;

          &.is-active {
            color: #000000;
          }
        }
      }

      .el-textarea__inner {
        padding: 15px 20px;
        font-size: 18px;
      }
    }
  }

  .video-container {
    display: flex;
    justify-content: center;
  }
}
</style>
